import { disableFacet, enableFacet, updateFacetOptions, } from '../../../../features/facet-options/facet-options-actions.js';
import { isFacetEnabledSelector } from '../../../../features/facet-options/facet-options-selectors.js';
import { deselectAllFacetValues } from '../../../../features/facets/facet-set/facet-set-actions.js';
import { baseFacetResponseSelector, isFacetLoadingResponseSelector, } from '../../../../features/facets/facet-set/facet-set-selectors.js';
import { updateRangeFacetSortCriterion } from '../../../../features/facets/range-facets/generic/range-facet-actions.js';
import { isRangeFacetValueExcluded, isRangeFacetValueSelected, } from '../../../../features/facets/range-facets/generic/range-facet-utils.js';
import { buildController } from '../../../controller/headless-controller.js';
export function buildCoreRangeFacet(engine, props) {
    const { facetId, getRequest } = props;
    const controller = buildController(engine);
    const dispatch = engine.dispatch;
    const getIsEnabled = () => isFacetEnabledSelector(engine.state, facetId);
    return {
        ...controller,
        isValueSelected: isRangeFacetValueSelected,
        isValueExcluded: isRangeFacetValueExcluded,
        deselectAll() {
            dispatch(deselectAllFacetValues(facetId));
            dispatch(updateFacetOptions());
        },
        sortBy(criterion) {
            dispatch(updateRangeFacetSortCriterion({ facetId, criterion }));
            dispatch(updateFacetOptions());
        },
        isSortedBy(criterion) {
            return this.state.sortCriterion === criterion;
        },
        enable() {
            dispatch(enableFacet(facetId));
        },
        disable() {
            dispatch(disableFacet(facetId));
        },
        get state() {
            const request = getRequest();
            const response = baseFacetResponseSelector(engine.state, facetId);
            const sortCriterion = request.sortCriteria;
            const resultsMustMatch = request.resultsMustMatch;
            const values = response ? response.values : [];
            const isLoading = isFacetLoadingResponseSelector(engine.state);
            const enabled = getIsEnabled();
            const hasActiveValues = values.some((facetValue) => facetValue.state !== 'idle');
            const domain = response?.domain;
            return {
                facetId,
                values,
                sortCriterion,
                resultsMustMatch,
                hasActiveValues,
                isLoading,
                enabled,
                domain,
            };
        },
    };
}
